export default __webpack_public_path__ + "static/media/plain-sticker-U.6ca8ed52.png";